var exports = {
  "kL": "CompactVoiceCallView.module__container___RXdWZX",
  "gw": "CompactVoiceCallView.module__containerNoHeader___RXdWZX",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___RXdWZX",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___RXdWZX",
  "ap": "CompactVoiceCallView.module__containerFillHeight___RXdWZX",
  "tZ": "CompactVoiceCallView.module__contentArea___RXdWZX",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___RXdWZX",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___RXdWZX",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___RXdWZX",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___RXdWZX",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___RXdWZX",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___RXdWZX",
  "D9": "CompactVoiceCallView.module__layoutHost___RXdWZX",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___RXdWZX",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___RXdWZX",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___RXdWZX",
  "_t": "CompactVoiceCallView.module__controlBarSection___RXdWZX",
  "Vw": "CompactVoiceCallView.module__controlBarInner___RXdWZX",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___RXdWZX",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___RXdWZX",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___RXdWZX",
  "x8": "CompactVoiceCallView.module__heightTogglePill___RXdWZX",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___RXdWZX",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___RXdWZX",
  "Di": "CompactVoiceCallView.module__resizeHandle___RXdWZX",
  "YC": "CompactVoiceCallView.module__resizePill___RXdWZX",
  "$I": "CompactVoiceCallView.module__containerResizing___RXdWZX",
};

module.exports = exports;
